const actions = {
  INIT_DATA: 'ECOMMERCE_INIT_DATA',
  INIT_DATA_SAGA: 'ECOMMERCE_INIT_DATA_SAGA',
  UPDATE_DATA: 'UPDATE_DATA',
  UPDATE_DATA_SAGA: 'ECOMMERCE_UPDATE_DATA_SAGA',
  UPDATE_SPECIFIC_VENTA: 'UPDATE_SPECIFIC_VENTA',
  DELETE_SPECIFIC_VENTA: 'DELETE_SPECIFIC_VENTA',
  CHANGE_VIEW: 'ECOMMERCE_CHANGE_VIEW',
  SET_CLIENTE: 'SET_CLIENTE',
  SET_VENTA: 'SET_VENTA',
  ADD_VENTA: 'ADD_VENTA',
  VIEW_TOPBAR_CART: 'ECOMMERCE_VIEW_TOPBAR_CART',
  RESET_VENTA: 'RESET_VENTA',
  GET_VENTAS_USER: 'GET_VENTAS_USER',
  GET_VENTAS: 'GET_VENTAS',
  FORMATEAR_VENTAS: 'FORMATEAR_VENTAS',
  DELETE_VENTA: 'DELETE_VENTA',
  EDIT_VENTA: 'EDIT_VENTA',
  DESCARGAR_VENTAS: 'DESCARGAR_VENTAS',
  SET_PAGINATION_INFO: 'SET_PAGINATION_INFO',
  SET_ARCHIVAR: 'SET_ARCHIVAR',
  initData: () => ({ type: actions.INIT_DATA_SAGA }),
  deleteVenta: (id, query) => ({ type: actions.DELETE_VENTA, id, query }),
  editVenta: (id, data, query) => ({ type: actions.EDIT_VENTA, id, data, query }),
  setCliente: data => ({ type: actions.SET_CLIENTE, data }),
  getVentas: query => ({ type: actions.GET_VENTAS, query }),
  getVentasUser: (data, query) => ({ type: actions.GET_VENTAS_USER, data, query }),
  procesarVenta: (venta) => ({ type: actions.SET_VENTA, venta }),
  descargarVentas: (idsVentas) => ({ type: actions.DESCARGAR_VENTAS, idsVentas }),
  actualizarProductos: products => {
    return {
        type: actions.UPDATE_DATA,
        products,
    };
  },
};
export default actions;
